import Vue from 'vue'
import Router from 'vue-router'
// const Home = () => import( /* webpackChunkName: "home" */ './views/Home.vue')
// const Home2 = () => import( /* webpackChunkName: "home" */ './views/Home2.vue')
const Home3 = () => import( /* webpackChunkName: "home" */ './views/Home2.vue')
const Detail = () => import( /* webpackChunkName: "about" */ './views/Detail.vue')
const Info = () => import( /* webpackChunkName: "about" */ './views/Info.vue')
const PayInfo = () => import( /* webpackChunkName: "about" */ './views/PayInfo.vue')

const About = () => import( /* webpackChunkName: "about" */ './views/About.vue')
const Pay = () => import( /* webpackChunkName: "about" */ './views/Pay.vue')
const PaySuccess = () => import( /* webpackChunkName: "about" */ './views/PaySuccess.vue')



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home3',
      redirect: '/home3',
      component: Home3
    },
    {
      path: '/home3',
      name: 'home3',
      component: Home3
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/info',
      name: 'Info',
      component: Info
    },
    {
      path: '/pay-info',
      name: 'PayInfo',
      component: PayInfo
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay
    }, {
      path: '/pay-success',
      name: 'paySuccess',
      component: PaySuccess
    },

  ]
})